import { render, staticRenderFns } from "./portraitDetails.vue?vue&type=template&id=16cf04f2&scoped=true&"
import script from "./portraitDetails.vue?vue&type=script&lang=js&"
export * from "./portraitDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cf04f2",
  null
  
)

component.options.__file = "portraitDetails.vue"
export default component.exports